import type { ErrorType } from '~/data/ErrorRecord';
import type { UserFields } from './User';

export const defaultState: UserListFields = {
  isLoading: false,
  users: [],
  error: undefined,
};

export interface UserListFields {
  isLoading: boolean;
  users: UserFields[];
  error?: ErrorType;
}
